module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "font-size": "75%"
    },
    attrs: {
      "id": "Copyright"
    }
  }, [_c('p', {
    staticClass: "copy"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_vm._v("First published in Great Britain in 2016 by"), _c('br'), _vm._v("Pen & Sword Aviation"), _c('br'), _vm._v("an imprint of"), _c('br'), _vm._v("Pen & Sword Books Ltd"), _c('br'), _vm._v("47 Church Street"), _c('br'), _vm._v("Barnsley"), _c('br'), _vm._v("South Yorkshire"), _c('br'), _vm._v("S70 2AS")])]), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_c('p', {
    staticClass: "copy"
  }, [_vm._v("Copyright © Robert A. Forczyk 2016")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("ISBN: 978 1 78346 278 0"), _c('br'), _vm._v("\nPDF ISBN: 978 1 47388 093 1"), _c('br'), _vm._v("\nEPUB ISBN: 978 1 47388 092 4"), _c('br'), _vm._v("\nPRC ISBN: 978 1 47388 091 7")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("The right of Robert A. Forczyk to be identified as the Author of this Work has been asserted by him in accordance with the Copyright, Designs and Patents Act 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("A CIP catalogue record for this book is available from the British Library")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced or transmitted in any form or by any means, electronic or mechanical including photocopying, recording or by any information storage and retrieval system, without permission from the Publisher in writing.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Typeset in Ehrhardt by Mac Style Ltd, Bridlington, East Yorkshire Printed and bound in the UK by CPI Group (UK) Ltd, Croydon, CRO 4YY")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Pen & Sword Books Ltd incorporates the imprints of Pen & Sword Archaeology, Atlas, Aviation, Battleground, Discovery, Family History, History, Maritime, Military, Naval, Politics, Railways, Select, Transport, True Crime, and Fiction, Frontline Books, Leo Cooper, Praetorian Press, Seaforth Publishing and Wharncliffe.")])]), _c('p', {
    staticClass: "copy"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_vm._v("For a complete list of Pen & Sword titles please contact"), _c('br'), _vm._v("PEN & SWORD BOOKS LIMITED"), _c('br'), _vm._v("47 Church Street, Barnsley, South Yorkshire, S70 2AS, England"), _c('br'), _vm._v("E-mail: ")]), _c('a', {
    attrs: {
      "href": "mailto:enquiries@pen-and-sword.co.uk"
    }
  }, [_vm._v("enquiries@pen-and-sword.co.uk")]), _c('br'), _vm._v("Website: "), _c('a', {
    attrs: {
      "href": "http://www.pen-and-sword.co.uk/",
      "target": "_blank"
    }
  }, [_vm._v("www.pen-and-sword.co.uk")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e620bc9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Copyright.vue
// module id = 60
// module chunks = 0